import React from "react"
import { RiErrorWarningLine } from "react-icons/ri"

import {
  isStorePaused,
  storePausedMessage,
  isShippingDelayed,
  shippingDelayMessage,
} from "../../helpers/isStorePaused"

const SitewideBanner = () => {
  const storePaused = isStorePaused()
  const shippingDelayed = isShippingDelayed()

  // Show nothing if neither state is active
  if (!storePaused && !shippingDelayed) return null

  // Choose correct message
  const message = storePaused ? storePausedMessage : shippingDelayMessage

  return (
    <div className="sitewide-banner" role="status">
      <RiErrorWarningLine className="sitewide-banner__icon" />
      <span>{message}</span>
    </div>
  )
}

export default SitewideBanner
